module.exports = __webpack_public_path__ + "img/kalimotxo.85c9cd88.jpg";